<template>
  <app-page :labelledby="pageState ? '' : 'transfer-template-new-title'">
    <app-state
      v-if="pageState"
      :state="pageState"
      :title="pageState === 'loading' ? 'Загружаем счета' : 'Не удалось открыть редактор'"
      :message="pageMessage"
      action-label="Повторить"
      @retry="loadBills"
    />
    <transfer-template-editor
      v-else
      mode="new"
      :bills="bills"
      :initial-value="initialValue"
      :save-state="saveState"
      :save-error="saveError"
      @cancel="$router.push({ name: 'transfer_templates_list' })"
      @save="saveTemplate"
    />
  </app-page>
</template>

<script>
import AppPage from '../../../components/ui/AppPage.vue'
import AppState from '../../../components/ui/AppState.vue'
import { normalizeCompactBillsResponse } from '../../../services/financeCore'
import TransferTemplateEditor from './TransferTemplateEditor.vue'

export default {
  name: 'transfer_templates_new',
  components: { AppPage, AppState, TransferTemplateEditor },
  data() {
    return {
      bills: [],
      initialValue: { lines: [] },
      loading: true,
      error: '',
      saveState: 'idle',
      saveError: '',
      handlers: []
    }
  },
  computed: {
    pageState() {
      if (this.loading) return 'loading'
      if (this.error) return 'error'
      return ''
    },
    pageMessage() {
      return this.error || 'Подготавливаем список счетов для строк шаблона.'
    }
  },
  mounted() {
    this.listen('didReceiveBillListFlatCompact', this.onBills)
    this.listen('onCreateTransferTemplate', this.onSaved)
    this.listen('connectionReady', this.loadBills)
    if (this.connection.isAuthenticated) this.loadBills()
  },
  beforeUnmount() {
    this.handlers.forEach(([event, handler]) => this.emitter.off(event, handler))
  },
  methods: {
    listen(event, handler) {
      this.emitter.on(event, handler)
      this.handlers.push([event, handler])
    },
    loadBills() {
      this.loading = true
      this.error = ''
      this.connection.gitBillsListFlatCompact('transfer-template-new-bills')
    },
    onBills(response) {
      const normalized = normalizeCompactBillsResponse(response)
      this.loading = false
      if (!normalized.ok) {
        this.error = normalized.message
        return
      }
      this.bills = normalized.bills
    },
    saveTemplate(payload) {
      if (this.saveState === 'saving') return
      this.saveState = 'saving'
      this.saveError = ''
      this.connection.createTransferTemplate('transfer-template-new-save', payload)
    },
    onSaved(response) {
      if (response.type === 'error' || response.error) {
        this.saveState = 'error'
        this.saveError = response.message || 'Не удалось сохранить шаблон'
        return
      }
      this.saveState = 'saved'
      this.$router.push({ name: 'transfer_templates_list' })
    }
  }
}
</script>
